import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "time-countdown-day"
};
var _hoisted_2 = {
  key: 1
};
import dayjs from 'dayjs';
import { useLess } from '@/models/hooks';
export default {
  __name: 'CountDown',
  props: {
    time: {
      type: Number
    }
  },
  emits: ['finish'],
  setup(__props, {
    emit
  }) {
    useLess('components/CountDown.less');
    return (_ctx, _cache) => {
      var _component_van_count_down = _resolveComponent("van-count-down");
      return _openBlock(), _createBlock(_component_van_count_down, {
        time: __props.time,
        class: "van-count-down",
        onFinish: _cache[0] || (_cache[0] = $event => emit('finish'))
      }, {
        default: _withCtx(timeData => [timeData.days > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(timeData.days) + _toDisplayString(_ctx.$t('common.DAYS')), 1)) : _createCommentVNode("", true), timeData.hours > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(timeData.hours) + ":", 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_unref(dayjs)().minute(timeData.minutes).format('mm')) + ":", 1), _createElementVNode("span", null, _toDisplayString(_unref(dayjs)().second(timeData.seconds).format('ss')), 1)]),
        _: 1
      }, 8, ["time"]);
    };
  }
};